/**
 * Returns a callback to initialize the slick behavior.
 * @param {Element} component
 * @return {Function} A callback function
 */
const handleContentsliderInit = (component) => () => {
    const setArrowBgColors = () => {
        $('style[data-id]').remove();
        const hoverBgColor = $('.content-wrapper').first().find('.slick-current').first()
                .find('.hero__content--text')
                .first()
                .css('background-color');
        const css = `[data-gallery] .slick-arrow:hover { background-color: ${hoverBgColor} }`;
        const styleElement = document.createElement('style');
        styleElement.setAttribute('data-id', 'slickarrowhovercss');
        styleElement.innerHTML = css;
        document.getElementsByTagName('head')[0].appendChild(styleElement);
    };
    $(component).on('init', setArrowBgColors);
    $(component).on('afterChange', setArrowBgColors);
    $(component).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        focusOnSelect: true,
        centerMode: false,
        dots: false,
        arrows: true,
        infinite: true,
        swipeToSlide: true,
        touchThreshold: 200,
        autoplay: true,
        autoplaySpeed: 8000,
        adaptiveHeight: true,
        init: () => {
            $(component).on('touchstart', () => {
                $(component).slick('slickPlay');
            });
            $(component).slick('slickPlay');
            $('.content-wrapper section').css({ display: 'block' });
        },
        responsive: [
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });
    setTimeout(() => {
        if (typeof $.fn.slick === 'function') {
            $(component).slick('slickPlay');
        }
    }, 4999);
};

export default handleContentsliderInit;



// WEBPACK FOOTER //
// ./src/scripts/components/gallery/handleContentsliderInit.js